module.exports = __webpack_public_path__ + "static/media/TF.2559326d.png";